"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "DEFAULT_THEME_CONTEXT", {
  enumerable: true,
  get: function get() {
    return _constants.DEFAULT_THEME_CONTEXT;
  }
});
_Object$defineProperty(exports, "ThemeContext", {
  enumerable: true,
  get: function get() {
    return _ThemeContext.default;
  }
});
_Object$defineProperty(exports, "ThemeContextType", {
  enumerable: true,
  get: function get() {
    return _type.ThemeContextType;
  }
});
_Object$defineProperty(exports, "ThemeSelector", {
  enumerable: true,
  get: function get() {
    return _ThemeSelector.default;
  }
});
_Object$defineProperty(exports, "TicketShopBreakPoints", {
  enumerable: true,
  get: function get() {
    return _constants.TicketShopBreakPoints;
  }
});
_Object$defineProperty(exports, "TicketShopTheme", {
  enumerable: true,
  get: function get() {
    return _constants.TicketShopTheme;
  }
});
_Object$defineProperty(exports, "TicketShopThemeLabel", {
  enumerable: true,
  get: function get() {
    return _constants.TicketShopThemeLabel;
  }
});
_Object$defineProperty(exports, "TicketShopThemeVariables", {
  enumerable: true,
  get: function get() {
    return _constants.TicketShopThemeVariables;
  }
});
exports.default = void 0;
_Object$defineProperty(exports, "withThemeConsumer", {
  enumerable: true,
  get: function get() {
    return _withThemeConsumer.default;
  }
});
var _constants = require("./constants");
var _ThemeContext = _interopRequireDefault(require("./ThemeContext"));
var _ThemeSelector = _interopRequireDefault(require("./ThemeSelector"));
var _type = require("./type");
var _withThemeConsumer = _interopRequireDefault(require("./withThemeConsumer"));
function cov_1zggtpzs4l() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/index.js";
  var hash = "78c5d6d7da730e34ce269c92c43b06b0e58575d6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "78c5d6d7da730e34ce269c92c43b06b0e58575d6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1zggtpzs4l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1zggtpzs4l();
var _default = exports.default = _ThemeContext.default;